// PotreeViewer3 리팩토링 - Three.js 씬 오브젝트 생성/정리 모듈
// 지침: PotreeViewer3.jsx의 viewer 생성/초기화 코드는 그대로 두고,
//       순수 Three.js 오브젝트 생성/정리 함수만 이 모듈로 분리한다.

import * as THREE from "three";

// TODO (다음 단계에서 이동 예정):
// - visualizePath(viewer, swaths, headlandCoords, bezierCurves, startPointRef, getMinZ) // L948–1045
// - placeRhombusAlongCoords({ coords, interval, scene, size, groupName, startPointRef, getMinZ }) // L1070–1143
// - createStartPointMesh(viewer, pointWGS84, startPointRef, getMinZ)                   // L580–603
// - GradientCover(viewer)                                                               // L175–216
// - getMinZ(viewer)                                                                     // L126–134

// -----------------------------------------------------------------------------
// getMinZ — 포인트클라우드 바운딩박스의 최소 Z값 반환
// -----------------------------------------------------------------------------

export function getMinZ(potreeViewer) {
  if (!potreeViewer) return 0;
  const pointCloud = potreeViewer.scene.pointclouds[0];
  if (!pointCloud) return 0;
  const box = pointCloud.boundingBox
    .clone()
    .applyMatrix4(pointCloud.matrixWorld);
  return box.min.z;
}

// -----------------------------------------------------------------------------
// createRhombusMesh / clearRhombusMarkers
// -----------------------------------------------------------------------------

// 원본: PotreeViewer3.jsx L1047–1058
export function createRhombusMesh(size = 1, height = 0.5) {
  const geometry = new THREE.BoxGeometry(size, height, size);
  const material = new THREE.MeshBasicMaterial({
    color: 0x00ff00,
    side: THREE.DoubleSide,
    transparent: true,
    opacity: 0.6,
  });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.rotation.y = -Math.PI / 4;
  return mesh;
}

// 원본: PotreeViewer3.jsx L1059–1069
export function clearRhombusMarkers(scene) {
  const existing = scene.getObjectByName("ridge-rhombus-markers");
  if (existing) {
    existing.traverse((child) => {
      child.geometry?.dispose?.();
      child.material?.dispose?.();
    });
    scene.remove(existing);
  }
}

